import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Pages are lazy-loaded chunks. A deploy replaces them, so a tab opened
// before the deploy can fail to load the next page; reload to get the new
// build. The timestamp stops a reload loop if a chunk is genuinely missing.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'chunkReloadAt';
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(key)) || 0;
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    // sessionStorage unavailable; fall through and reload once.
  }
  if (Date.now() - last > 10_000) {
    event.preventDefault();
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Trigger rebuild Mon, Jan 12, 2026  5:14:14 PM
